export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-950"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20interior%20with%20warm%20red%20velvet%20curtains%20and%20gold%20accents%2C%20soft%20dramatic%20lighting%2C%20elegant%20movie%20theater%20atmosphere%2C%20rich%20textures%2C%20professional%20cinematography%20aesthetic%2C%20warm%20golden%20and%20deep%20crimson%20tones%2C%20abstract%20theatrical%20backdrop%20with%20bokeh%20lights&width=1800&height=900&seq=hero-bg-lulu-01&orientation=landscape"
          alt="鲁鲁影院 - 高清免费在线影视平台"
          className="w-full h-full object-cover object-center"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left Text */}
          <div className="flex-1 text-center lg:text-left w-full">
            {/* Tag */}
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/20 border border-accent-400/30 text-accent-300 text-xs md:text-sm font-medium mb-5">
              <i className="ri-fire-fill text-accent-400 text-xs"></i>
              每日更新 · 热播速递
            </span>

            {/* H1 */}
            <h1
              className="text-3xl md:text-5xl lg:text-5xl font-extrabold text-white leading-tight mb-3"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              鲁鲁影院<span className="text-accent-400"> · </span>
              <span className="block md:inline text-accent-300">高清免费在线追剧平台</span>
            </h1>

            {/* Slogan */}
            <p className="text-sm md:text-base text-white/60 font-medium mb-6 tracking-wide">
              不缓冲 · 不付费 · 不妥协 — 每一帧都清晰，每一秒都流畅
            </p>

            {/* Intro */}
            <p className="text-sm md:text-base text-white/75 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              鲁鲁影院汇聚全网热播电影、电视剧与综艺资源，高清画质搭配极速加载，无需注册即可在线畅享海量内容。
              每日同步更新最新剧集，覆盖动作、悬疑、喜剧、爱情、科幻等全类型题材，
              无论你是追剧达人还是电影爱好者，这里都是你的专属高清免费影视天地。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-400" style={{ fontFamily: 'var(--font-heading)' }}>
                  30,000+
                </div>
                <div className="text-xs text-white/50 mt-0.5">高清片源</div>
              </div>
              <div className="w-px h-8 bg-white/15"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-400" style={{ fontFamily: 'var(--font-heading)' }}>
                  每日更新
                </div>
                <div className="text-xs text-white/50 mt-0.5">追剧不等待</div>
              </div>
              <div className="w-px h-8 bg-white/15"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-400" style={{ fontFamily: 'var(--font-heading)' }}>
                  全端适配
                </div>
                <div className="text-xs text-white/50 mt-0.5">手机电脑随心看</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="whitespace-nowrap cursor-pointer px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-white text-sm md:text-base font-semibold transition-colors no-underline"
              >
                <i className="ri-play-circle-fill mr-1.5"></i>
                开始免费观影
              </a>
              <a
                href="#ranking"
                className="whitespace-nowrap cursor-pointer px-8 py-3 rounded-full border border-white/20 hover:border-white/40 text-white/80 hover:text-white text-sm md:text-base font-medium transition-colors no-underline"
              >
                <i className="ri-fire-line mr-1.5"></i>
                查看热播排行
              </a>
            </div>
          </div>

          {/* Right Visual */}
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              {/* Decorative glow */}
              <div className="absolute -inset-8 bg-accent-500/10 rounded-3xl blur-3xl"></div>

              {/* Main visual image */}
              <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20movie%20poster%20collage%20with%20warm%20golden%20and%20crimson%20tones%2C%20film%20reel%20and%20cinematic%20elements%2C%20dramatic%20lighting%2C%20theatrical%20composition%2C%20vintage%20cinema%20aesthetic%20with%20modern%20twist%2C%20no%20text%2C%20artistic%20film%20montage&width=800&height=1000&seq=hero-visual-lulu-02&orientation=portrait"
                  alt="鲁鲁影院 - 高清在线影视体验"
                  className="w-full h-auto object-cover"
                />
              </div>

              {/* Floating badge */}
              <div className="absolute -bottom-3 -right-3 bg-background-50 rounded-xl px-4 py-3 shadow-lg border border-background-200/60 flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-primary-500 text-sm font-bold">HD</span>
                </div>
                <div>
                  <div className="text-xs text-foreground-900 font-semibold whitespace-nowrap">高清画质</div>
                  <div className="text-[10px] text-foreground-500">1080P 流畅播放</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}